// Transport Canada ERAP reference numbers look like "2-1234" or "2-1234-567":
// a single leading digit, a 4-digit group, and an optional 3-digit group.

/**
 * Formats raw input into the ERAP plan-number shape, inserting the hyphens
 * automatically as digits are typed (X-XXXX-XXX). Non-digits are stripped and
 * the value is capped at 8 digits.
 */
export function formatErapPlanNumber(raw: string): string {
  const digits = raw.replace(/\D/g, "").slice(0, 8);
  if (digits.length <= 1) {
    return digits;
  }
  if (digits.length <= 5) {
    return `${digits[0]}-${digits.slice(1)}`;
  }
  return `${digits[0]}-${digits.slice(1, 5)}-${digits.slice(5)}`;
}

/**
 * A complete ERAP plan number. The pattern is served by the shipment-limits endpoint
 * (`ShipmentLimits.DangerousGoods.ERAP_PLAN_NUMBER_PATTERN` on the backend is the source of
 * truth), so the same rule rejects the value here and at the API.
 */
export function isValidErapPlanNumber(value: string, pattern: string): boolean {
  return new RegExp(pattern).test(value);
}
